export default "__VITE_PUBLIC_ASSET__879eeeaa__"